import keys from '@debbie/common/dist/cache/keys.js';
import { Site } from '@debbie/common/dist/index.js';
import { IntentType } from '@debbie/common/dist/intents/index.js';
import { Direction, InteractionType, OutgoingState, } from '@debbie/common/dist/interactions/index.js';
import { UpdateType } from '@debbie/common/dist/updates/index.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import { plaintextToHtml } from '@debbie/common/dist/util/html.js';
import * as interactions from '@debbie/cortex/dist/api/interactions.js';
import * as updatesAPI from '@debbie/cortex/dist/api/updates.js';
import { useCase } from '@debbie/cortex/dist/cases/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { interactionsEntity } from '@debbie/cortex/dist/interactions/index.js';
import q from '@debbie/cortex/dist/query.js';
import { useTemplatesMap } from '@debbie/cortex/dist/templates/index.js';
import { updatesEntity, useUpdatesByRefId, } from '@debbie/cortex/dist/updates/index.js';
import moment from 'moment';
import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
import { errorNotification } from '../../utils/errors.js';
import AIGeneratedIndicator from '../Email/AIGeneratedIndicator.js';
import HTMLEmail from '../Email/HTMLEmail.js';
import { Badge, Button, File, Input, Intent, Modal, Panel, Well, } from '../index.js';
import Events from '../interactions/Events/Events.js';
import OppositionHistory from '../OppositionHistory.js';
import { MetaData } from './Helpers.js';
const DefaultSummary = (props) => {
    const singleCaseLoader = useCase(props.longCaseId);
    const singleCase = h.hasData(singleCaseLoader) ? singleCaseLoader.data : null;
    const site = useSelector((s) => s.site);
    const lang = useSelector((s) => s.lang);
    const updatesLoadable = useUpdatesByRefId(singleCase?.caseId);
    const updates = h.hasData(updatesLoadable) ? updatesLoadable.data : null;
    const templatesMapLoadable = useTemplatesMap();
    const templatesMap = h.hasData(templatesMapLoadable)
        ? templatesMapLoadable.data
        : null;
    const template = (props.interaction.templateId &&
        templatesMap?.[props.interaction.templateId]) ||
        null;
    const [oppositionModalOpen, setOppositionModalOpen] = useState(false);
    const [oppositionNote, setOppositionNote] = useState('');
    const notesHtml = useMemo(() => plaintextToHtml(props.interaction.notes ?? ''), [props.interaction.notes]);
    const verifyMutation = useMutation(async () => {
        await interactions.patch(props.interaction.id, {
            state: OutgoingState.SENT,
        });
        q.invalidate(keys.write.modify(interactionsEntity, props.interaction.id));
    }, {
        onError: (err) => {
            errorNotification(lang, err, 'update', lang.errorEntities.interaction);
        },
    });
    const oppositionMutation = useMutation(async (updateTypeId) => {
        if (!singleCase) {
            return;
        }
        await updatesAPI.make({
            referenceId: singleCase.caseId,
            updateTypeId,
            update: oppositionNote || null,
            remindedAt: moment().format(),
            pausedAt: moment().format(),
            continuedAt: moment().format(),
            refId: props.interaction.id,
        });
        q.invalidate(keys.write.create(updatesEntity));
        setOppositionModalOpen(false);
    }, {
        onError: (err) => {
            errorNotification(lang, err, 'create', lang.errorEntities.update);
        },
    });
    const oppositions = updates
        ? updates.filter((update) => {
            if (update.refId === props.interaction.id) {
                if ([UpdateType.OPPOSITION, UpdateType.NOTOPPOSITION].includes(update.updateTypeId)) {
                    return true;
                }
            }
            return false;
        })
        : [];
    return (React.createElement(React.Fragment, null,
        React.createElement(Panel, { id: `interaction-${props.interaction.id}`, style: {
                opacity: !props.notActionable &&
                    props.interaction.state === OutgoingState.PENDING
                    ? typeof props.transparrent === 'boolean'
                        ? props.transparrent
                            ? 0.6
                            : 1
                        : 0.6
                    : 1,
            } },
            site === Site.Caseworker && props.interaction.aiGenerated && (React.createElement("div", { style: {
                    margin: '-20px -20px 20px -20px',
                } },
                React.createElement(AIGeneratedIndicator, { aiAutoReplyId: props.interaction.aiAutoReplyId }))),
            template && (React.createElement("h3", { style: { margin: '0 0 0.5em 0', fontSize: '0.9em' } },
                lang.interactions.template,
                ": ",
                template.name,
                !!template.tags?.length &&
                    template.tags.map(({ tag }) => (React.createElement(Badge, { theme: THEME.COLOR_ACCENT, style: { marginLeft: '0.5em' }, key: tag }, lang.templateTags[tag]))))),
            (!!props.children ||
                !!props.metaData?.length ||
                !!(props.interaction.notes && !props.notesOutsideBox)) && (React.createElement("div", { style: {
                    border: `1px solid ${THEME.BORDER_STRONG}`,
                    padding: '10px',
                    borderRadius: '3px',
                } },
                props.metaData && props.metaData.length !== 0 && (React.createElement("div", { style: {
                        margin: '-10px -10px 10px -10px',
                    } },
                    React.createElement(MetaData, { metaData: props.metaData }))),
                React.createElement("div", null, props.children),
                !props.notesOutsideBox && props.interaction.notes && (React.createElement("div", { style: {
                        margin: '0.6em 0 0em 0',
                    } },
                    React.createElement(HTMLEmail, { html: notesHtml }))))),
            props.notesOutsideBox && props.interaction.notes && (React.createElement("div", { style: {
                    margin: '0 0 0 0',
                } },
                React.createElement(HTMLEmail, { html: notesHtml }))),
            props.interaction.direction === Direction.OUTGOING &&
                props.interaction.intent &&
                props.interaction.intent.type !== IntentType.Unknown ? (React.createElement("p", { style: {
                    margin: '0.6em 0 0em 0',
                    fontSize: '0.9em',
                } },
                React.createElement(Intent, { editable: false, intent: props.interaction.intent }))) : ([]),
            site === Site.Caseworker && !!props.interaction.events?.length && (React.createElement("p", { style: {
                    margin: '0.6em 0 0em 0',
                    fontSize: '0.9em',
                } },
                React.createElement(Events, { interaction: props.interaction }))),
            site === Site.Caseworker &&
                (props.interaction.type === InteractionType.Phone ||
                    (props.interaction.direction === Direction.INCOMING &&
                        ![InteractionType.Note, InteractionType.ClientNote].includes(props.interaction.type))) && (React.createElement(OppositionHistory, { interaction: props.interaction, caseId: props.longCaseId, lang: lang }))),
        props.interaction.details && props.interaction.attachments ? (React.createElement("div", { style: { marginTop: '-10px', marginBottom: '10px' } }, props.interaction.attachments.map((attachment) => (React.createElement(File, { key: attachment.fileId, file: {
                fileName: attachment.fileName,
                fileId: attachment.fileId,
                contentType: attachment.contentType,
            } }))))) : null,
        React.createElement("div", { style: { marginTop: '-10px' } },
            !props.notActionable &&
                site === Site.Caseworker &&
                props.interaction.state === OutgoingState.PENDING && (React.createElement(Button, { onClick: () => verifyMutation.mutate(), loading: verifyMutation.isLoading, size: "small" }, lang.interactions.verify)),
            !props.notActionable &&
                singleCase &&
                site === Site.Caseworker &&
                (props.interaction.type === InteractionType.Phone ||
                    (props.interaction.direction === Direction.INCOMING &&
                        ![InteractionType.Note, InteractionType.ClientNote].includes(props.interaction.type))) && (React.createElement("div", null,
                React.createElement(Button, { onClick: () => {
                        setOppositionModalOpen(!oppositionModalOpen);
                    }, style: { marginRight: '5px' }, size: "small", theme: oppositions.length ? 'secondary' : undefined },
                    lang.interactions.opposition,
                    "/",
                    lang.interactions.notOpposition),
                oppositionModalOpen && (React.createElement(Modal, { header: lang.interactions.opposition +
                        '/' +
                        lang.interactions.notOpposition, onToggle: () => {
                        setOppositionModalOpen(!oppositionModalOpen);
                    }, maxWidth: "450px" },
                    React.createElement(Well, null,
                        React.createElement(Input, { placeholder: lang.interactions.optionalNote, value: oppositionNote, onChange: (e) => {
                                setOppositionNote(e.target.value);
                            } }),
                        React.createElement(Inline, null,
                            React.createElement(Button, { onClick: () => oppositionMutation.mutate(UpdateType.OPPOSITION), loading: oppositionMutation.isLoading }, lang.interactions.opposition),
                            React.createElement(Button, { onClick: () => oppositionMutation.mutate(UpdateType.NOTOPPOSITION), loading: oppositionMutation.isLoading }, lang.interactions.notOpposition))))))))));
};
export default DefaultSummary;
const Inline = styled.div `
  display: inline-flex;
  width: 100%;
  justify-content: space-between;
`;
//# sourceMappingURL=DefaultSummary.js.map